import { aiMessages } from '@atlaskit/editor-common/ai-messages/ai';

import { createInsertBelow } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactory,
	EditorPluginAIConfigItemFactoryOptions,
} from '../../config-items';

export type ExtractListActionType =
	| 'list_key_topics'
	| 'list_key_themes'
	| 'extract_insights'
	| 'extract_key_insights'
	| 'extract_user_quotes'
	| 'list_todos'
	| 'add_related_work_items';

type SmartlinkExtractListOptions = EditorPluginAIConfigItemFactoryOptions & {
	actionType: ExtractListActionType;
	smartlinkUrl: string;
};

type SmartlinkExtractListConfigItemFactory = (
	options: SmartlinkExtractListOptions,
) => ReturnType<EditorPluginAIConfigItemFactory>;

export const smartLinkExtractList: SmartlinkExtractListConfigItemFactory = (
	options: SmartlinkExtractListOptions,
) => ({
	key: CONFIG_ITEM_KEYS.SMARTLINK_EXTRACT_LIST,
	title: aiMessages.smartlinkListKeyTopics,
	description: aiMessages.smartlinkListKeyTopics,
	showInRefineDropdown: false,
	insertOnEmptySelection: true,
	// intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
	intentSchemaId: 'smartlink_extract_list_intent_schema.json',
	featureId: 'smartlink_extract_list',
	adfPrompt: true,
	getRequestPayload: ({ locale, aiSessionId, contentAri }) => ({
		ai_feature_input: {
			feature: 'smartlink_extract_list',
			feature_args: {
				smartlink_url: options.smartlinkUrl,
				smartlink_action_type: options.actionType,
			},
			locale,
			ai_session_id: aiSessionId,
			content_ari: contentAri,
		},
	}),
	actions: {
		empty: [createInsertBelow({ appearance: 'primary' })],
		selection: [createInsertBelow({ appearance: 'primary' })],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});
